module.exports = __webpack_public_path__ + "img/shuju.0a7cdc55.png";